"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var cdnDomain = 'https://assets.peerspace.com';
var redirect = 'https://peerspace.app.link/SouAXJdIRcb';
var AppBanner = function AppBanner(_ref) {
  var toggleBanner = _ref.toggleBanner,
    intl = _ref.intl;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-banner flex middle space-between"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn-link remove-click-styling ico-sm icon-close-sidebar no-gutter",
    onClick: function onClick() {
      return toggleBanner(true);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: cdnDomain + "/iOSIcon.svg?v=rb",
    width: 48,
    alt: intl.formatMessage({
      id: 'homepage.app_banner.ios_icon',
      defaultMessage: 'small peerspace logo'
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "description-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "heavy"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.app_banner.for_ios",
    defaultMessage: "Peerspace for iOS"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "star-container flex middle"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "",
    src: cdnDomain + "/5StarRating.svg?v=rb",
    alt: intl.formatMessage({
      id: 'homepage.app_banner.rating_stars',
      defaultMessage: '5 star app review'
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "app-review-count margin-sm-left"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.app_banner.review_count",
    defaultMessage: "2.2k"
  })))), /*#__PURE__*/_react.default.createElement("span", {
    className: "flex"
  }), /*#__PURE__*/_react.default.createElement("a", {
    className: "btn btn-secondary",
    href: redirect
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "homepage.app_banner.button_download",
    defaultMessage: "Download"
  })));
};
AppBanner.PropTypes = {
  toggleBanner: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)(AppBanner);